export default "__VITE_ASSET__75b0e8b5__"